import React, { useState } from "react";
import module from "./ForgotPass.module.css";
import LoginContainer from "../components/atomic/molecular/LoginContainer";
import PrimaryLinkButton from "../components/atomic/ui/PrimaryLinkButton";
import { CircularProgress, TextField } from "@mui/material";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";

const ForgotPass = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsLoading(true);
      const email = e.target.email.value;
      if (email === "") {
        setIsLoading(false);
        alert("メールアドレスを入力してください");
        return null;
      }
      await Auth.forgotPassword(email);
      setIsLoading(false);
      navigate("/forgot/confirm");
      localStorage.setItem("signUpEmail", email);
    } catch (e) {
      if (e.code === "InvalidParameterException") {
        // 検討項目
        // alert("このメールアドレスは登録されていません");
      }
      setIsLoading(false);
    }
  };

  return (
    <LoginContainer label={"パスワードをお忘れの方"}>
      <div className={module.container}>
        <div className={module.wrapSub}>
          <p>
            ご登録されたメールアドレス宛に
            <br />
            パスワード再発行手続きメッセージを送信いたします
          </p>
        </div>
        <div className={module.wrapConformCode}>
          <form className={module.form} onSubmit={handleSubmit}>
            <div className={module.wrapLabel}>
              <span>メールアドレス</span>
            </div>
            <div className={module.wrapInputs}>
              <TextField
                maxRows={1}
                variant="outlined"
                placeholder="例：sample@nosh.jp"
                name="email"
                fullWidth
              />
            </div>
            {isLoading ? (
              <div>
                <CircularProgress color="success" />
              </div>
            ) : (
              <PrimaryLinkButton
                label={"パスワードを送信する"}
                type={"submit"}
              />
            )}
          </form>
        </div>
      </div>
    </LoginContainer>
  );
};

export default ForgotPass;
